import { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { apiJson } from '../lib/api.js';

const card = {
  background: '#fff',
  borderRadius: 18,
  padding: '32px 36px',
  boxShadow: '0 18px 48px rgba(20, 5, 60, 0.08)',
  border: '1px solid var(--border, #ece8f6)',
  maxWidth: 440,
  margin: '60px auto',
};
const input = {
  width: '100%', padding: '10px 12px', borderRadius: 10,
  border: '1px solid var(--border, #d8d6e6)', marginBottom: 14, fontSize: 14.5,
  boxSizing: 'border-box',
};
const primaryBtn = {
  width: '100%', padding: '12px 16px', borderRadius: 10, border: 'none',
  background: 'linear-gradient(135deg, #5b21b6, #7c3aed)', color: '#fff',
  fontSize: 15, fontWeight: 700, cursor: 'pointer',
};

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    if (password !== confirm) {
      setErr('The two passwords don\'t match.');
      return;
    }
    setSubmitting(true);
    try {
      await apiJson('/api/auth/reset-password', { method: 'POST', body: { token, password } });
      setDone(true);
      setTimeout(() => navigate('/login', { replace: true }), 2500);
    } catch (e2) {
      setErr(e2.message || 'Could not reset your password. The link may have expired.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mm-auth-page" style={{ padding: 24, minHeight: '100vh', background: 'var(--bg, #f7f5fc)' }}>
      <div className="mm-auth-card" style={card}>
        <div style={{ fontSize: 12, fontWeight: 700, color: '#5b21b6', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: 8 }}>
          Set a new password
        </div>

        {!token ? (
          <>
            <h1 style={{ margin: '0 0 8px', fontSize: 24, color: '#991b1b' }}>Link incomplete</h1>
            <p style={{ color: '#6b7280', lineHeight: 1.6, fontSize: 14.5 }}>
              This reset link is missing its token. Request a fresh one and use the most recent email.
            </p>
            <Link to="/forgot-password" style={{ display: 'inline-block', marginTop: 16, color: '#5b21b6', fontWeight: 600 }}>
              Request a new link →
            </Link>
          </>
        ) : done ? (
          <>
            <h1 style={{ margin: '0 0 8px', fontSize: 24, color: '#15803d' }}>Password updated ✓</h1>
            <p style={{ color: '#4b4361', lineHeight: 1.6, fontSize: 14.5 }}>
              You can now sign in with your new password. Redirecting you to sign in…
            </p>
            <Link to="/login" style={{ display: 'inline-block', marginTop: 14, color: '#5b21b6', fontWeight: 600 }}>
              Go to sign in →
            </Link>
          </>
        ) : (
          <>
            <h1 style={{ margin: '0 0 18px', fontSize: 24 }}>Choose a new password</h1>

            {err && (
              <div className="mm-auth-error" style={{ background: '#fee2e2', color: '#991b1b', borderRadius: 8, padding: '8px 12px', fontSize: 13.5, marginBottom: 12 }}>
                {err}
              </div>
            )}

            <form onSubmit={submit} noValidate>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 6 }}>New password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
                required
                minLength={8}
                autoFocus
                placeholder="At least 8 characters, 1 letter + 1 number"
                style={input}
              />
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 6 }}>Confirm new password</label>
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                autoComplete="new-password"
                required
                minLength={8}
                placeholder="Re-enter your new password"
                style={input}
              />
              <button type="submit" className="mm-auth-primary" disabled={submitting || !password || !confirm} style={{ ...primaryBtn, marginTop: 4, opacity: submitting || !password || !confirm ? 0.6 : 1 }}>
                {submitting ? 'Updating…' : 'Update password'}
              </button>
            </form>

            <div style={{ marginTop: 16, fontSize: 13.5 }}>
              <Link to="/login" style={{ color: '#5b21b6' }}>← Back to sign in</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
